import html from './loader.html';
import {emitter, EVENTS} from '../../../utils/emitter';
import {partial} from '../../../utils/partial';
import {sleep} from '../../../utils/helpers';
import {TweenMax} from 'gsap';
import {AssetLoader} from '../../../modules/assetLoader';
import {rootPath} from '../../../configs/global';

export class Loader {
  private element: HTMLElement;
  private loaderGif: HTMLElement;
  private loader: AssetLoader;

  constructor() {
    this.element = partial(html, '#loader');
    this.loaderGif = this.element.querySelector(`.loader-image`);

    this.loader = new AssetLoader([
      {
        loader: `image`,
        url: `${rootPath}assets/images/textures/multi.jpg`
      }
    ]);

    this.presetAnimation();
    this.render();
  }

  private render() {
    document.body.prepend(this.element);
  }

  public async start() {
    this.loader.load();

    await Promise.all([this.loader.load(), sleep(2)]);

    // set loaded class for preloader to
    // know the site is loaded and ready to render
    document.querySelector('#app').classList.add('loaded');
    emitter.emit(EVENTS.loaded, {});
  }

  public presetAnimation() {
    TweenMax.set(this.loaderGif, {opacity: 0, y: 10});
  }

  public animateIn(delay = 0) {
    return new Promise(resolve => {
      TweenMax.to(this.loaderGif, 0.3, {opacity: 1, y: 0, onComplete: resolve, delay});
    });
  }

  public async animateOut(delay = 0) {
    this.element.style.pointerEvents = `none`;
    TweenMax.to(this.loaderGif, 0.25, {opacity: 0, y: 10, delay});
    TweenMax.to(this.element, 1.8, {opacity: 0, delay: delay + 0.8});
    await sleep(delay + 2.5); // wait before resolve and deletion
  }

  public kill() {
    this.element.remove();
  }
}
